var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_20003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1872 147.82L586.863 149.163C588.316 149.168 589.738 149.615 590.913 150.467C593.184 152.123 595.869 154.77 589.773 154.77L76.2133 161.764C74.9124 161.781 73.8508 160.733 73.8508 159.434V150.15C73.8508 148.859 74.895 147.816 76.1872 147.82Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4812 147.836V161.71",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1871 147.819H28.7559C28.7559 147.819 37.1135 147.054 44.1486 152.847C52.7456 159.919 65.2756 163.974 73.8464 156.581L76.1871 147.819Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8217 154.111C64.8912 152.903 62.9797 151.811 60.5522 151.672C58.1246 151.532 56.1004 152.398 56.0309 153.606C55.9614 154.814 57.8729 155.906 60.3004 156.045C62.728 156.185 64.7522 155.319 64.8217 154.111Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.54 122.334L535.037 123.143C531.714 116.366 528.916 96.3469 528.916 96.3469C530.513 95.9992 532.083 95.6559 533.632 95.3125C533.632 95.3125 537.878 118.483 539.54 122.334Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.037 123.143L239.499 176.256C239.499 176.256 96.6312 201.57 89.1001 203.008C82.5915 204.247 40.3593 212.227 28.9866 214.379C27.2594 214.705 25.5017 214.027 24.4402 212.623C22.4084 209.937 23.8528 206.051 27.1419 205.334C62.0562 197.736 215.322 164.395 229.323 161.7C240.909 159.466 429.215 118.214 528.916 96.3477C528.916 96.3477 531.713 116.367 535.037 123.143Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.76 121.577V121.582L539.54 122.338C537.878 118.487 533.632 95.3164 533.632 95.3164C535.063 95.0035 536.473 94.6949 537.857 94.3906C537.857 94.3906 541.62 116.627 543.76 121.577Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.857 108.553L599.275 111.6L543.761 121.575C541.62 116.624 537.857 94.388 537.857 94.388C569.199 87.5164 589.782 82.9961 589.782 82.9961L587.272 86.521L593.894 87.3903L590.061 91.5324L596.783 92.5408L591.697 97.3436L599.154 98.8083L593.824 103.576L600.964 103.924L597.274 107.332L603.857 108.553Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.652 93.0703L538.435 97.7036",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.716 95.8281C568.716 95.8281 546.967 99.8399 539.545 103.339",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.234 99.1719C575.234 99.1719 549.238 103.097 540.454 108.386",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.333 103.773C559.645 106.012 542.151 112.345 541.054 111.28",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.333 108.223C566.445 109.483 544.252 116.742 542.125 116.046",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.133 118.093C467.153 118.745 461.815 120.492 453.832 123.1L448.062 106.393L464.191 100.608C464.595 100.464 465.022 100.751 465.035 101.181C465.096 103.594 465.626 110.613 469.472 117.172C469.677 117.519 469.516 117.967 469.133 118.093Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.831 123.098C388.602 144.409 146.794 223.252 119.524 232.145C118.023 232.632 116.374 232.119 115.417 230.867C114.895 230.185 114.647 229.394 114.647 228.616C114.647 227.116 115.552 225.665 117.114 225.108L448.062 106.391L453.831 123.098Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.296 102.258L464.765 119.426",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.319 104.258L459.957 121.213",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.818 107.536C468.002 100.951 472.574 92.154 485.222 89.1636C497.869 86.1733 514.867 83.8219 516.912 70.6001C517.891 73.3601 516.516 76.6025 516.516 76.6025C519.762 74.2555 520.702 67.2969 520.702 67.2969C521.924 69.983 520.945 73.7426 520.945 73.7426C522.294 73.0906 523.573 68.4574 523.573 68.4574C523.643 79.08 512.514 97.387 495.476 106.458C477.786 115.872 467.354 112.734 467.354 112.734C467.354 112.734 466.314 110.352 465.818 107.536Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.21 103.924C470.382 103.102 470.525 103.602 469.616 105.936C469.59 106.005 469.624 106.088 469.698 106.11C470.355 106.301 470.821 106.388 472.744 105.327C473.605 105.001 474.397 106.245 473.575 107.236C473.327 107.535 473.227 107.931 473.357 108.296C473.51 108.705 473.958 109.009 474.68 108.522C475.489 107.979 477.312 107.766 476.76 109.309C476.207 110.852 472.344 111.438 467.027 111.591L465.892 107.914L467.21 103.924Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.82 100.816C471.187 99.6472 471.709 100.96 474.028 98.8084C474.506 98.2825 476.129 98.4998 475.389 100.264C475.476 100.273 475.698 100.286 475.942 100.295C476.664 100.33 477.343 99.8124 477.395 99.0866C477.399 99.0301 477.399 98.9779 477.395 98.9214C478.757 98.8736 479.927 98.7084 479.666 100.808C480.119 101.164 482.007 100.33 482.15 98.9431C483.682 98.778 484.778 99.1083 484.613 100.712C485.714 100.829 486.07 98.6606 486.07 98.6606C486.81 98.6389 488.724 99.1431 488.459 100.56C489.581 100.164 489.655 98.8997 489.655 98.8997C491.874 99.6125 493.336 98.7084 493.336 98.7084C493.336 98.7084 491.235 97.7435 491.326 94.9792C490.612 95.227 488.876 95.7572 488.041 97.3132C486.819 96.0267 487.119 94.0317 487.119 94.0317C485.37 94.0795 483.908 93.7622 479.14 96.9134C477.613 96.9612 475.52 96.1658 474.728 94.0273C473.64 94.9488 471 97.0177 468.82 100.816Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.659 108.744C481.072 108.26 481.191 107.684 480.926 107.458C480.661 107.233 480.111 107.443 479.698 107.927C479.286 108.412 479.166 108.988 479.432 109.213C479.697 109.439 480.247 109.229 480.659 108.744Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.843 107.897C485.175 107.508 485.191 106.977 484.88 106.713C484.569 106.449 484.048 106.55 483.716 106.939C483.385 107.329 483.368 107.859 483.679 108.123C483.99 108.388 484.512 108.286 484.843 107.897Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.7 87.4494C508.249 87.0055 508.525 86.4369 508.317 86.1794C508.108 85.9218 507.494 86.0728 506.945 86.5167C506.395 86.9605 506.119 87.5291 506.328 87.7867C506.536 88.0442 507.15 87.8932 507.7 87.4494Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.36 102.082C492.735 101.779 492.925 101.39 492.783 101.215C492.641 101.039 492.221 101.143 491.846 101.447C491.47 101.75 491.281 102.138 491.423 102.314C491.565 102.489 491.984 102.385 492.36 102.082Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.603 87.9963C513.812 87.6738 513.867 87.3383 513.725 87.2471C513.584 87.1559 513.3 87.3434 513.092 87.666C512.883 87.9885 512.828 88.324 512.969 88.4152C513.111 88.5064 513.394 88.3189 513.603 87.9963Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.216 82.9846C516.384 82.9846 516.521 82.6732 516.521 82.2892C516.521 81.9051 516.384 81.5938 516.216 81.5938C516.048 81.5938 515.912 81.9051 515.912 82.2892C515.912 82.6732 516.048 82.9846 516.216 82.9846Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.896 108.31C362.219 104.194 365.304 102.429 368.841 102.433C378.373 102.446 382.985 111.083 386.426 124.709C389.868 138.335 394.558 170.485 395.393 178.322C396.002 184.028 396.681 188.892 393.957 196.763C390.246 207.512 383.594 224.489 374.097 238.159C371.229 242.279 367.758 249.385 364.786 256.27C361.815 263.155 371.25 365.564 371.25 365.564H281.25C281.25 365.564 287.735 268.384 287.526 259.708C273.822 253.332 271.416 244.552 265.973 235.877C260.53 227.201 254.413 203.274 254.413 203.274C242.114 216.879 235.353 200.332 233.299 189.674C231.163 178.574 227.713 157.32 229.158 143.033C230.598 128.747 250.55 127.786 253.243 135.344C253.826 124.452 258.516 113.23 262.888 111.7C267.387 110.127 282.132 112.035 287.861 113.582C290.246 108.736 292.934 105.315 295.366 104.159C300.061 101.925 321.462 102.26 325.869 107.371C327.579 104.767 329.537 102.703 331.682 101.708C339.043 98.2956 356.272 101.364 359.896 108.31Z",
    fill: "#FF7051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.218 109.028C357.451 101.578 339.291 98.1795 331.682 101.709C324.172 105.19 318.908 121.872 318.908 128.417C318.908 137.406 319.33 159.877 322.354 172.72C324.473 181.713 332.634 193.822 341.588 187.698C349.646 182.187 357.055 173.09 355.593 144.286C354.027 113.361 360.035 102.422 368.837 102.435C378.369 102.448 382.981 111.084 386.422 124.71C389.863 138.336 394.554 170.486 395.389 178.323C395.998 184.03 396.677 188.893 393.953 196.765C390.238 207.509 383.59 224.49 374.088 238.155C370.164 243.801 363.498 257.084 363.498 261.43C362.193 274.47 371.5 367.066 371.5 367.066L281.5 365.066L287.613 260.648C275.975 254.059 264.159 239.751 254.418 203.267",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.874 107.37C321.466 102.259 300.065 101.924 295.371 104.154C290.676 106.383 285.007 117.062 282.475 130.158C279.943 143.25 282.458 179.281 285.273 189.126C288.088 198.97 301.196 203.417 311.964 195.615C320.305 189.574 322.354 172.718 322.354 172.718",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.866 113.583C282.132 112.041 267.391 110.128 262.889 111.702C258.386 113.275 253.548 125.128 253.204 136.307C252.238 149.815 255.719 183.052 264.703 188.755C276.828 196.452 284.899 187.668 284.899 187.668",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.247 135.348C250.554 127.786 230.602 128.746 229.162 143.037C227.722 157.324 231.168 178.582 233.304 189.678C235.44 200.775 242.684 218.265 255.971 201.435C260.365 195.268 260.404 184.337 258.986 180.069",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.531 221.961C309.328 249.1 323.972 253.112 323.972 253.112",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.728 154.789C355.798 173.566 356.08 177.725 357.425 181.172C358.769 184.618 355.68 184.736 352.943 187.587C350.207 190.438 339.382 203.269 337.838 222.641",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.151 172.442L447.836 181.43C447.662 182.113 446.984 182.539 446.292 182.404L437.373 180.687L440.458 169.082L449.12 170.803C449.873 170.951 450.342 171.699 450.151 172.442Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.458 169.082L437.373 180.687L431.917 179.639L434.254 167.852L440.458 169.082Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.254 167.854L431.917 179.641L428.328 178.95L429.89 166.984L434.254 167.854Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.89 166.981L428.328 178.946L421.941 177.721L424.834 165.977L429.89 166.981Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.587 110.483L132.581 117.025L121.726 112.031C120.299 111.374 120.873 109.223 122.439 109.371L134.587 110.483Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.893 172.526L421.941 177.724L424.834 165.98L392.983 159.656L394.893 172.526Z",
    fill: "#E7E5E4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.142 112.094C152.142 112.094 153.991 115.979 154.669 118.109C152.738 118.174 149.958 118.47 149.958 118.47C149.958 118.47 151.337 121.086 153.395 121.943C151.611 122.725 148.008 124.12 148.008 124.12",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.925 145.49L152.503 126.192L132.581 117.026L134.586 110.484L152.142 112.097L253.099 132.143L252.925 145.49Z",
    fill: "#E7E5E4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8862 102.972L-8.95148 82.7043C-9.53882 82.5826 -9.91733 82.0046 -9.79116 81.4178C-9.66499 80.831 -9.0907 80.4529 -8.50336 80.5789L-8.49465 80.5833L88.1342 101.824C88.4518 101.894 88.652 102.207 88.5823 102.524C88.5127 102.837 88.2038 103.037 87.8862 102.972Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4334 126.838L-8.81669 119.684C-9.41708 119.636 -9.86085 119.11 -9.81299 118.514C-9.76514 117.919 -9.2387 117.471 -8.64266 117.519C-8.63831 117.519 -8.63396 117.519 -8.62961 117.519L80.5291 125.764C80.825 125.79 81.0469 126.055 81.0208 126.351C80.9903 126.647 80.7293 126.864 80.4334 126.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.333 175.36L-8.58613 186.295C-9.18218 186.374 -9.73037 185.956 -9.80868 185.361C-9.88699 184.766 -9.46932 184.218 -8.87328 184.14C-8.86893 184.14 -8.86023 184.14 -8.86023 184.14L73.2025 174.312C73.494 174.278 73.7551 174.486 73.7899 174.773C73.8247 175.06 73.6202 175.321 73.333 175.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.537 208.176L-8.38599 252.126C-8.95594 252.313 -9.56938 252.005 -9.76081 251.435C-9.94789 250.866 -9.63899 250.253 -9.06905 250.062L-9.06035 250.058L125.211 207.185C125.485 207.098 125.776 207.25 125.863 207.524C125.955 207.793 125.807 208.084 125.537 208.176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.446 253.747L-4.97347 325.273C-5.49991 325.564 -6.16121 325.378 -6.45271 324.852C-6.7442 324.326 -6.55712 323.665 -6.03069 323.374L-6.02634 323.37L118.715 252.422C119.081 252.222 119.542 252.352 119.742 252.721C119.942 253.087 119.811 253.547 119.446 253.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.125 237.02L82.4438 367.156C82 367.561 81.3126 367.526 80.908 367.078C80.5034 366.635 80.5382 365.948 80.9863 365.544L80.995 365.535L218.576 236.407C218.746 236.259 219.007 236.272 219.155 236.442C219.303 236.611 219.29 236.868 219.125 237.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.406 236.937L140.124 367.591C139.75 368.061 139.067 368.139 138.597 367.765C138.127 367.391 138.049 366.709 138.423 366.239C138.427 366.235 138.432 366.231 138.432 366.226L242.849 236.489C242.975 236.337 243.201 236.315 243.354 236.441C243.506 236.563 243.528 236.785 243.406 236.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.005 264.078L185.818 367.302C185.5 367.811 184.83 367.967 184.321 367.65C183.812 367.332 183.655 366.663 183.973 366.155C183.977 366.15 183.982 366.142 183.986 366.133L247.2 263.56C247.343 263.339 247.643 263.278 247.865 263.421C248.079 263.565 248.144 263.856 248.005 264.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.429 267.454L455.937 371.8C456.25 372.312 456.089 372.982 455.576 373.295C455.062 373.608 454.392 373.447 454.079 372.934C454.075 372.93 454.07 372.921 454.066 372.917L395.458 268.032C395.302 267.763 395.393 267.419 395.663 267.258C395.924 267.106 396.268 267.193 396.429 267.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.069 251.716L527.613 365.187C528.022 365.626 528 366.312 527.561 366.721C527.121 367.13 526.434 367.108 526.025 366.669C526.025 366.665 526.016 366.66 526.016 366.656L424.286 252.437C424.09 252.22 424.103 251.885 424.321 251.685C424.538 251.49 424.873 251.503 425.069 251.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.336 209.461L649.408 305.169C649.943 305.438 650.156 306.095 649.887 306.629C649.617 307.164 648.96 307.377 648.425 307.107L648.421 307.103L459.879 210.356C459.631 210.23 459.535 209.926 459.661 209.678C459.788 209.435 460.088 209.335 460.336 209.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.172 173.61L648.991 179.821C649.591 179.86 650.043 180.378 650.004 180.978C649.965 181.577 649.447 182.029 648.847 181.99C648.843 181.99 648.838 181.99 648.834 181.99L555.094 174.671C554.802 174.649 554.58 174.393 554.607 174.097C554.628 173.81 554.885 173.593 555.172 173.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.634 139.572L648.877 136.364C649.478 136.342 649.982 136.807 650.004 137.407C650.026 138.007 649.56 138.511 648.96 138.533C648.956 138.533 648.947 138.533 648.947 138.533L563.669 140.597C563.386 140.606 563.147 140.38 563.143 140.093C563.134 139.819 563.356 139.585 563.634 139.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.21 97.7925L648.738 90.2862C649.33 90.1819 649.895 90.5774 650 91.1685C650.104 91.7597 649.708 92.3247 649.117 92.429C649.108 92.429 649.095 92.4333 649.086 92.4333L606.354 98.6835C606.106 98.7182 605.879 98.5487 605.84 98.301C605.806 98.0576 605.971 97.8316 606.21 97.7925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 83.1905L648.621 53.4872C649.199 53.322 649.8 53.661 649.965 54.2347C650.13 54.8128 649.791 55.4126 649.217 55.5778C649.212 55.5778 649.204 55.5821 649.204 55.5821L543.865 83.9294C543.66 83.9859 543.447 83.8642 543.395 83.6599C543.338 83.4556 543.456 83.247 543.656 83.1905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.024 63.3083L656.097 15.173C656.654 14.9426 657.289 15.2078 657.519 15.7598C657.75 16.3118 657.485 16.9507 656.932 17.181C656.923 17.1854 656.915 17.1897 656.906 17.1897L534.437 64.3297C534.154 64.4384 533.832 64.295 533.723 64.0124C533.61 63.7386 533.749 63.4213 534.024 63.3083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.694 78.7965L582.219 -9.10113C582.745 -9.38799 583.407 -9.19675 583.694 -8.67083C583.981 -8.14492 583.79 -7.48426 583.263 -7.1974C583.259 -7.19305 583.25 -7.18871 583.246 -7.18871L444.125 79.6006C443.899 79.718 443.625 79.631 443.507 79.405C443.394 79.1921 443.477 78.9182 443.694 78.7965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.963 84.9198L438.588 -8.58893C438.975 -9.04965 439.658 -9.10615 440.119 -8.72367C440.581 -8.33684 440.637 -7.65445 440.254 -7.19374C440.25 -7.18939 440.241 -7.1807 440.241 -7.17635L370.846 85.6717C370.633 85.9107 370.268 85.9368 370.029 85.7238C369.789 85.5196 369.763 85.1588 369.963 84.9198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.043 84.3054L367.496 -9.77941C367.679 -10.3488 368.292 -10.6661 368.862 -10.4835C369.432 -10.301 369.75 -9.68814 369.567 -9.11876C369.563 -9.11007 369.558 -9.09703 369.558 -9.09268L340.122 84.6661C340.017 84.9617 339.691 85.1182 339.395 85.0139C339.104 84.9139 338.947 84.5966 339.043 84.3054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.323 83.7092L319.147 -10.8903C319.13 -11.4901 319.604 -11.99 320.204 -12.0073C320.805 -12.0247 321.305 -11.551 321.323 -10.9512C321.323 -10.9381 321.323 -10.9251 321.323 -10.9121L322.275 83.7006C322.275 83.9613 322.058 84.1743 321.797 84.1743C321.54 84.17 321.331 83.9657 321.323 83.7092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.08 82.2448L282.279 -8.09342C282.136 -8.67584 282.497 -9.2626 283.08 -9.40603C283.663 -9.54946 284.25 -9.18871 284.394 -8.60629C284.394 -8.5976 284.398 -8.58456 284.402 -8.57587L303.254 81.9797C303.324 82.3057 303.115 82.6229 302.793 82.6925C302.471 82.7577 302.158 82.5577 302.08 82.2448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.189 91.2358L203.586 -17.9342C203.234 -18.421 203.347 -19.0991 203.834 -19.4511C204.321 -19.8032 205 -19.6902 205.352 -19.2034C205.357 -19.199 205.361 -19.1903 205.366 -19.186L284.098 90.5969C284.272 90.849 284.207 91.1923 283.954 91.3662C283.702 91.5401 283.363 91.4792 283.189 91.2358Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.399 103.722L140.199 -6.07987C139.729 -6.45366 139.651 -7.13604 140.025 -7.60546C140.399 -8.07487 141.082 -8.1531 141.552 -7.77931C141.557 -7.77497 141.565 -7.77062 141.565 -7.76627L265.842 103.174C265.995 103.296 266.016 103.517 265.89 103.669C265.768 103.817 265.551 103.839 265.399 103.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.193 103.767L-2.01526 -4.44605C-2.57215 -4.67206 -2.83754 -5.30664 -2.61131 -5.86298C-2.38507 -6.41932 -1.74987 -6.68445 -1.19298 -6.45843L-1.18428 -6.45409L217.458 103.132C217.632 103.206 217.715 103.406 217.641 103.584C217.567 103.754 217.367 103.836 217.193 103.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.0076 1.56778L92.8332 65.1397L71.8194 64.1227L96.2572 76.8879L83.9447 77.4399L110.053 93.4434L38.9542 67.6389L60.9861 70.2554L38.9542 58.481L52.2847 60.702L-55 1.51562L-27.0076 1.56778Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.006 90.196L188.918 76.2571L196.836 76.7265L173.008 61.3793L182.101 60.9099L90.5369 -10.9336H73.9999L160.086 58.1282L152.546 57.5415L175.357 70.1504L164.385 70.698L210.006 90.196Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.008 99.5828L445.646 60.2913L422.992 64.5856C422.992 64.5856 489.183 -3.28068 505.75 -7.68359C500.403 -7.68359 468 -9.68359 468 -9.68359L406.837 61.2345L418.898 60.8172L398.445 78.1072C398.445 78.1072 417.149 73.2045 411.554 78.2115C406.515 82.7188 389.008 99.5828 389.008 99.5828Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.913 230.81C648.913 230.81 637.536 225.72 587.451 197.056L608.164 220.974L552.815 191.971C552.815 191.971 569.03 210.034 570.896 213.09C563.339 210.378 525.732 192.479 502.473 185.781C502.473 185.781 537.196 211.395 594.16 243.115C594.16 243.115 589.565 232.444 581.838 220.557C589.922 224.282 619.846 240.607 627.395 245.575C626.329 242.823 622.509 232.444 622.509 232.444C622.509 232.444 644.323 246.996 648.913 248.326C648.913 245.388 648.913 230.81 648.913 230.81Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 370.816C628.5 370.816 518.617 289.605 493.562 258.902C493.105 260.818 497.295 272.88 495.99 275.709C491.687 271.354 467.288 239.186 467.288 239.186C467.288 239.186 470.795 249.209 469.672 253.764C466.583 250.752 444.904 232.332 444.904 232.332L474.51 270.589L474.019 258.393L502.154 294.699L502.085 284.046C502.085 284.046 609.631 364.179 616.857 370.816H628.5Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0342 367.066L172.407 266.256L142.105 273.254C142.105 273.254 168.822 252.339 177.341 246.754C172.529 247.727 155.239 251.235 155.239 251.235L173.443 235.453L127.547 261.236L154.787 256.233L112.585 282.733C112.585 282.733 129.174 276.044 138.598 275.914C131.511 281.825 20.75 367.066 20.75 367.066H43.0342Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4772 234.623C67.4772 234.623 36.0739 253.9 6.38914 268.182L19.7458 250.231L1.85572 260.376L5.13614 252.418L-8.92529 258.507V240.4L16.4653 232.363L3.10872 245.085L38.9671 235.097L28.1078 245.946L67.4772 234.623Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_20003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1);
export default __webpack_public_path__ + "static/media/grid1.f520a94919b02eaee272798deb3216d1.svg";
export { ForwardRef as ReactComponent };